import { createRoute } from '@tanstack/react-router'

import { rootRoute } from '@/routes/root'
import { ensureAuthenticatedUser } from '@/utils/auth-wall'

import { billingSearchSchema } from './schema'

export const billingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/billing',
  validateSearch: billingSearchSchema,
  beforeLoad: ensureAuthenticatedUser,
}).lazy(() => import('./view/billingRoot').then((d) => d.Route))
